interface IUpdateGlobalFontStylesFromTheme {
  fontSize: number;
  lineHeight: number;
  parsedTextColor?: string;
  headingsStyles?: () => string;
}

export function updateGlobalFontStylesFromTheme({
  fontSize = 16,
  lineHeight = 1.5,
  parsedTextColor = '#000',
  headingsStyles,
}: IUpdateGlobalFontStylesFromTheme) {
  return `
  .chameleon-text {
    ${parsedTextColor && `color: ${parsedTextColor};`}
  }

  .chameleon-text > div {
    p:not(h1 p, h2 p, h3 p, h4 p, h5 p, h6 p, .chameleon-certificate-text p) {
      font-size: ${fontSize}px !important;
      line-height: ${(fontSize / 16) * lineHeight}rem;
    }

    li:not(h1 li, h2 li, h3 li, h4 li, h5 li, h6 li, .chameleon-certificate-text li) {
      font-size: ${fontSize}px !important;
      line-height: ${(fontSize / 16) * lineHeight}rem;
    }

    // 
    ${headingsStyles && headingsStyles()}
  }

  li > span {
    ${parsedTextColor && `color: ${parsedTextColor};`}
  }

  `;
}
